import React, { Component } from "react";

import { backendToTime, dateFromNow } from "@js/utils/date";

import styles from "./style.module.scss";

type Props = { time?: Date | string; interval?: number };

export class TimeFromNow extends Component<Props> {
  updateTimeInterval: NodeJS.Timeout | undefined;

  static defaultProps = {
    interval: 10000,
  };

  timeRef: HTMLElement | null = null;

  componentDidMount() {
    this.updateTimeInterval = setInterval(() => {
      if (!this.timeRef) {
        return;
      }
      this.timeRef.innerHTML = this.time;
    }, this.props.interval);
  }

  componentWillUnmount() {
    clearInterval(this.updateTimeInterval);
  }

  get time() {
    return dateFromNow(this.props.time);
  }

  render() {
    return (
      <span className={styles.timeFromNow}>
        <abbr
          title={backendToTime(this.props.time).format(
            SETTINGS.DATE_TIME_FORMAT,
          )}
          ref={(ref) => {
            this.timeRef = ref;
          }}
        >
          {this.time}
        </abbr>
      </span>
    );
  }
}
